import { useContext } from 'react'
import { GridExportContext } from './GridExportContext'

export const useGridExport = () => {
  const context = useContext(GridExportContext)
  if (!context) {
    throw new Error('useGridExport pitää käyttää GridExportProvider:in sisällä')
  }
  return context
}
